import Vue from 'vue'
import './plugins/axios'
// import './plugins/axios_sql'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import sm2 from "@/utils/sm2"
import http from '@/utils/request'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
import * as echarts from 'echarts';
Vue.prototype.$sm2 = sm2;
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false
Vue.prototype.$urlss=`https://api.heiban.icu`;
Vue.prototype.$url=`https://lscl.dhand.cn/`;
// Vue.prototype.$url=`http://localhost:3001/`;
Vue.prototype.$urls=`https://api.heiban.icu/`
// Vue.prototype.$urls=`http://localhost:3001/`
Vue.prototype.$http = http
Vue.prototype.$baseURL = 'https://jiuye.heiban.icu';
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
